import React from "react";
import Photo from "../media/photo.PNG";
import "../styles/views.css";

const ThirdViews = () => {
  return (
    <div>
      <section class='section3'>
        <div className='item1'>
          <img src={Photo} alt='' />
        </div>
        <div>
          <h1>Create profiles for kids.</h1>
          <h2>
            Send kids on adventures with their favorite <br />
            characters in a space made just for them— <br />
            free with your membership.
          </h2>
        </div>
      </section>
    </div>
  );
};

export default ThirdViews;
